import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/containers/accordion.containers';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';

export default function PackagingTypeBasicInfoComponent({
    handleInnerFormChange,
    selectedCategory,
}: any) {
    return (
        <>
            <AccordionContainer
                headerTitle="New Packaging Type"
                expandedPanel="userInfo"
                child={
                    <div className="grid md:grid-cols-2 gap-4">

                        <InputContainer
                            label="Group Code"
                            name="Code"
                            type="text"
                            value={selectedCategory?.Code}
                            isDisabled={!!selectedCategory?.GlobalPackagingTypeId}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Code'
                                );
                            }}
                        />

                        <InputContainer
                            label="Group Name"
                            name="Name"
                            type="text"
                            value={selectedCategory?.Name}
                            isDisabled={!!selectedCategory?.GlobalPackagingTypeId}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Name'
                                );
                            }}
                        />
                        {selectedCategory?.GlobalPackagingTypeId &&
                            <div className="md:col-span-2">
                                <InputContainer
                                    label="IsActive"
                                    name="IsActive"
                                    type="checkbox"
                                    value={selectedCategory?.IsActive}
                                    onValueChange={(event: any) => {
                                        const value = event?.target ? event.target.checked : event;
                                        handleInnerFormChange(
                                            value,
                                            'IsActive'
                                        );
                                    }}
                                />
                            </div>
                        }
                    </div>
                }
            />
        </>
    );
}